import REMOVE_BUSINESS_USER from './removeBusinessUser.gql';
import SAVE_BUSINESS_USER from './saveBusinessUser.gql';

export {
  REMOVE_BUSINESS_USER,
  SAVE_BUSINESS_USER,
};
